var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 36,
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5714 19.4167V35H2.42857V19.4167M21 26.5V20.8333M26.7143 6.66667C26.7143 6.66667 26.7143 1 21 1C15.2857 1 15.2857 6.66667 15.2857 6.66667M1 6.66667H41V18C41 18 32.4286 23.6667 21 23.6667C9.57143 23.6667 1 18 1 18V6.66667Z",
    stroke: "#45C646",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefcase);
export default __webpack_public_path__ + "static/media/icon-briefcase.80b6034206c421ebd50360828356ce71.svg";
export { ForwardRef as ReactComponent };